import { Tooltip } from 'bootstrap';

export const tooltipDirective = {
    mounted(el, binding) {
        if (!binding.value) return;

        const options = {
            title: binding.value || '',
            placement: binding.arg || 'top',
            trigger: 'hover focus',
            html: el.getAttribute('data-bs-html') === 'true' || false,
            delay: el.getAttribute('data-bs-delay') ? parseInt(el.getAttribute('data-bs-delay')) : 0
        };

        el._tooltip = new Tooltip(el, options);
        el._tooltipPlacement = binding.arg;
    },
    updated(el, binding) {
        if (!binding.value) {
            // Remove tooltip if value becomes empty
            if (el._tooltip) {
                el._tooltip.dispose();
                delete el._tooltip;
                delete el._tooltipPlacement;
            }
            return;
        }

        const placementChanged = binding.arg !== el._tooltipPlacement;

        if (placementChanged) {
            // Placement changed — recreate tooltip (Bootstrap doesn't support dynamic placement update)
            if (el._tooltip) {
                el._tooltip.dispose();
            }
            el._tooltip = new Tooltip(el, {
                title: binding.value || '',
                placement: binding.arg || 'top',
                trigger: 'hover focus',
                html: el.getAttribute('data-bs-html') === 'true' || false,
                delay: el.getAttribute('data-bs-delay') ? parseInt(el.getAttribute('data-bs-delay')) : 0
            });
            el._tooltipPlacement = binding.arg;
        } else if (binding.value !== binding.oldValue) {
            // Only title changed — update content
            el._tooltip.setContent({ '.tooltip-inner': binding.value || '' });
        }
    },
    beforeUnmount(el) {
        if (el._tooltip) {
            el._tooltip.dispose();
            delete el._tooltip;
            delete el._tooltipPlacement;
        }
    }
};
